<div class="contact-content">
    <div>
        <h3>{{ specialityType.name | uppercase }} SZAKRENDELÉS TÍPUSÁNAK MÓDOSÍTÁSA</h3>
        <p [ngStyle]="{ 'text-align': 'center' }">A * - al jelölt mezők kitöltése kötelező!</p>
    </div>
    <div class="contact-form">
        <form novalidate [formGroup]="specialityTypeForm!">
            <div class="field-container">
                <div class="field">
                    <b>Szakrendelés típusának neve *</b>
                    <div class="data">
                        <input
                            formControlName="name"
                            id="name"
                            class="form-control"
                            type="text"
                            required
                            [(ngModel)]="specialityType.name"
                        />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <b>Szakrendelés típusának munkaköre *</b>
                    <div class="data">
                        <input
                            formControlName="jobTitle"
                            id="jobTitle"
                            class="form-control"
                            type="text"
                            required
                            [(ngModel)]="specialityType.jobTitle"
                        />
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="field-container" [ngStyle]="{ 'margin-top': '8px' }">
        <div class="field" [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }">
            <div class="data" [ngStyle]="{ 'justify-content': 'center' }">
                <button
                    [ngStyle]="{ background: '#eee', border: '1px solid #0E8388', 'font-weight': 'bold', width: '100%' }"
                    [disabled]="!specialityTypeForm?.valid"
                    (click)="updateSpecialityType()"
                >
                    SZAKRENDELÉS TÍPUSÁNAK MÓDOSÍTÁSA
                </button>
            </div>
        </div>
    </div>
</div>
